import { apiClient } from "../../lib/api-client";

export type PushSubscriptionStarter = () => Promise<void>;

interface ApiResponse<T> {
  data: T;
}

function applicationServerKey(value: string): Uint8Array<ArrayBuffer> {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const decoded = atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "="));
  return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
}

export async function startPushSubscription(): Promise<void> {
  const { public_key } = await apiClient
    .get<ApiResponse<{ public_key: string }>>("/push/vapid-key")
    .then((response) => response.data);
  const registration = await navigator.serviceWorker.ready;
  const subscription =
    (await registration.pushManager.getSubscription()) ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey(public_key),
    }));
  const serialized = subscription.toJSON();
  if (!serialized.endpoint || !serialized.keys?.p256dh || !serialized.keys.auth) {
    throw new Error("Browser returned an incomplete push subscription");
  }
  await apiClient.post("/push/subscriptions", {
    endpoint: serialized.endpoint,
    keys: serialized.keys,
  });
}
